import http from '../http'

export default {
  getRoles: () => {
    return http.get('/admin/role')
  },
  createRole: (role) => {
    return http.post('/admin/role', role)
  },
  updateRole: (role) => {
    return http.put('/admin/role/', role)
  },
  getInternalRoles: () => {
    return http.get('/admin/role/getAllInternal')
  },
  getExternalRoles: () => {
    return http.get('/admin/role/getAllExternal')
  },
  getRolePermissions: (roleId) => {
    return http.get(`/admin/role/${roleId}/permissions`)
  }
}
